import { render, staticRenderFns } from "./DynamicLoggerBasedDataSheet.vue?vue&type=template&id=4f84e86d"
import script from "./DynamicLoggerBasedDataSheet.vue?vue&type=script&lang=js"
export * from "./DynamicLoggerBasedDataSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports